import type {BioIconProps} from './common-types'

export function IconCalendar({fill = '#4F4F4F', ...attributes}: BioIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...attributes}>
      <g clipPath="url(#clip0_6645_33865)">
        <path
          d="M1.90625 2.84375H14.0938C14.0938 2.84375 15.0312 2.84375 15.0312 3.78125V14.0938C15.0312 14.0938 15.0312 15.0312 14.0938 15.0312H1.90625C1.90625 15.0312 0.96875 15.0312 0.96875 14.0938V3.78125C0.96875 3.78125 0.96875 2.84375 1.90625 2.84375Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M0.96875 6.59375H15.0312" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.71875 4.25V0.96875" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.2812 4.25V0.96875" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_6645_33865">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
